<template>
    <carousel draggable v-bind="slider.settings" :breakpoints="slider.breakpoints" ref="carouselslider" @mouseDrag="startDrag($event, item)">
        <slide v-for="(page, index) in items" :key="index+page.full_slug" @click="$router.push(page.route)" >
            <v-card  @mouseDrag="startDrag" @click="$router.push(page.route)" class="mx-2 w-100 bg-transparent">
                    <v-img
                        lazy
                        gradient="to bottom, rgba(0,0,0,1), rgba(33,33,33,1), rgba(33,33,33,0.51), rgba(0,0,0,0.31), rgba(0,0,0,0.1), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.2),  rgba(18,18,18,0.51), rgba(18,18,18,1), rgba(0,0,0,1)"
                        :lazy-src="page.thumbnail.sizes.thumbnail"
                        :src="page.thumbnail.sizes.full"
                        :aspect-ratio="8/5"
                        fetchpriority="low"
                        cover
                    >
                            <v-container class="fill-height d-none d-md-block">
                                <v-row class="fill-height text-start" align="end">

                                    <v-col cols="12">
                                        <a :href="page.full_slug" :title="removeSeparator(page.title)">
                                            <h3>{{ removeSeparator(page.title) }}</h3>
                                        </a>
                                    </v-col>

                                </v-row>
                            </v-container>
                    </v-img>
                    <v-container class="fill-height d-block d-md-none">
                                <v-row class="fill-height text-start" align="end">

                                    <v-col cols="12">
                                        <a :href="page.full_slug" :title="removeSeparator(page.title)">
                                            <h4>{{ removeSeparator(page.title) }}</h4>
                                        </a>
                                    </v-col>

                                </v-row>
                    </v-container>
            </v-card>
        </slide>
        <template #addons>
            <navigation  />
            <pagination class="d-none justify-end"/>
        </template>
    </carousel>
</template>



<script>


import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation,} from 'vue3-carousel'

export default{
   props:{
    items:{
        required: true,
        type: Array
    }
   },
   components: {
        Carousel,
        Slide,
        Pagination,
    Navigation,
    },
   data: () => ({
        slider:{
            settings:{ 
                "autoplay": 0,
                "snapAlign": "start",
                "wrapAround": false,
                "mouseDrag": true,
            },
            breakpoints:{
                0:{
                    itemsToShow: 1.7,
                },
                768:{
                    itemsToShow: 2.5,
                },
                1280:{
                    itemsToShow: 3.2,
                }
            }
        }
    }),
    mounted(){
        this.$refs['carouselslider'].$el.addEventListener('mouseDrag', this.mouseDrag)
        this.$refs['carouselslider'].$el.addEventListener('drag', this.mouseDrag)
    },
    methods:{
        removeSeparator(title){
            return title.replace("| Primerent", '');
        },
        disallowDrop(e){
            e.preventDefault();
        },
        startDrag(e, item){
            e.preventDefault();
        },
        isDragged(e){
            e.preventDefault();
        }
    }
}
</script>

<style scoped>
a{
    text-decoration: none;
}
</style>